<template>
  <div class="view learning-view">
    <HeaderBar />
    <div class="learning-title">{{title}}</div>
    <ul class="learning-list">
      <li class="learning-item">
        <div class="item-left">
          <img class="left-img" src="../../assets/images/learningwz.png" />
          <span class="left-text">共阅读文章</span>
        </div>
        <div class="item-right"><span class="right-text">{{news}}</span>篇</div>
      </li>

      <li class="learning-item">
        <div class="item-left">
          <img class="left-img" src="../../assets/images/learningbg.png" />
          <span class="left-text">共在线阅读研究报告</span>
        </div>
        <div class="item-right"><span class="right-text">{{report}}</span>份</div>
      </li>

      <li class="learning-item">
        <div class="item-left">
          <img class="left-img" src="../../assets/images/learningkj.png" />
          <span class="left-text">共在线查看课件</span>
        </div>
        <div class="item-right"><span class="right-text">{{pdf}}</span>个</div>
      </li>

      <li class="learning-item">
        <div class="item-left">
          <img class="left-img" src="../../assets/images/learningkc.png" />
          <span class="left-text">共在线学习视频课程</span>
        </div>
        <div class="item-right"><span class="right-text">{{viedo}}</span>节</div>
      </li>
    </ul>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import HeaderBar from '../../components/HeaderBar';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
export default {
  name: 'learning',
  components: {
    HeaderBar,
    Dialog
  },
  data(){
    return {
      title:'',
      pdf:0,
      report:0,
      news:0,
      viedo:0
    }
  },
  created() {
    this.init();
  },
  methods:{
    init() {
      this.getChartData();
    },
    async getChartData() {
      const res = await apiUtil.post(apiConst.getAchievement);
      console.log(res)
      if (res.success) {
        const {title,pdf,report,news,viedo} = res;
        this.title = title;
        this.pdf = pdf;
        this.report = report;
        this.news = news;
        this.viedo = viedo;
      }
    }
  }

};
</script>
<style lang="stylus" scoped>
.learning-view{

    .learning-title{
      height:127px;
      background-color: #F1F1F1;
      color: #333333;
      line-height 127px;
      text-align: center;
      font-size:34px;
    }
    .learning-list{
      margin-top:20px;

      .learning-item{
            display:flex;
            justify-content space-between
            margin:25px 30px;
            border-bottom:1px solid #F1F1F1;

            .item-left{
                height 131px;
                /*border:1px solid green;*/
                display: flex;
                flex-direction: row;
                align-items: center;
                .left-img{
                    display:inline-block;
                    margin-right 18px;
                    width:71px;
                    height:71px;
                }
                .left-text{
                  font-size:32px;
                  color: #666666;
                }
            }
            .item-right{
              display:flex;
              justify-content center;
              align-items: center;
                height 131px;
                font-size:32px;
                color: #666666;
              .right-text{
                font-size:52px;
                color:#1A92E7;
                padding-right:10px;
              }
            }
        }
    }
}
</style>
